export let PlatformAdminRole = /*#__PURE__*/function (PlatformAdminRole) {
  PlatformAdminRole["SUPER_ADMIN"] = "super_admin";
  PlatformAdminRole["SUPPORT_ADMIN"] = "support_admin";
  PlatformAdminRole["BILLING_ADMIN"] = "billing_admin";
  return PlatformAdminRole;
}({});
export let PlatformAdminStatus = /*#__PURE__*/function (PlatformAdminStatus) {
  PlatformAdminStatus["ACTIVE"] = "active";
  PlatformAdminStatus["INACTIVE"] = "inactive";
  PlatformAdminStatus["LOCKED"] = "locked";
  return PlatformAdminStatus;
}({});
//# sourceMappingURL=platform-admin.enum.js.map